import { Component, Input, OnInit } from '@angular/core';
import { EducationStepInterface } from 'src/app/shared/models/interfaces/education-step.interface';

@Component({
    template: '',
    standalone: true
})
export class BasicContentBlockComponent implements OnInit {


  @Input()
  block?: EducationStepInterface & { expandedPanel?: boolean }

  @Input()
  enabled!: boolean;

  @Input()
  iomId!: string;

  ngOnInit(): void {
    if(this.block) {
      this.block.expandedPanel = this.block?.opened;
    } 
  }
}
